import { render, staticRenderFns } from "./PartesInstituciones.vue?vue&type=template&id=4bbdae30&"
import script from "./PartesInstituciones.vue?vue&type=script&lang=js&"
export * from "./PartesInstituciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports